<template>
  <div id="FullPreview">
    <div class="full" v-if="!zbg">
      <div class="index">
        <div class="cover">
          <p class="title">{{year}}年煤炭企业管理现代化创新成果</p>
          <!-- <p class="title">2020年煤炭企业管理现代化创新成果</p> -->
          <p class="name">主报告</p>
          <div>
            <p>成果名称：{{cgmc}}</p>
            <p>申报单位：{{sbdw}}</p>
          </div>
          <p class="footer">中国煤炭工业协会</p>
        </div>
      </div>
      <div class="catalogue">
        <p class="title">目录</p>
        <div>
          <p>成果概要</p>
          <p>企业简介</p>
          <p>一、实施背景</p>
          <span>{{ssbjbt1}}</span>
          <span>{{ssbjbt2}}</span>
          <span>{{ssbjbt3}}</span>
          <p>二、内涵</p>
          <p>三、主要做法</p>
          <span>{{zyzfbt1}}</span>
          <span>{{zyzfbt2}}</span>
          <span>{{zyzfbt3}}</span>
          <span>{{zyzfbt4}}</span>
          <span>{{zyzfbt5}}</span>
          <span>{{zyzfbt6}}</span>
          <span>{{zyzfbt7}}</span>
          <p>四、实施效果</p>
          <span>{{ssxgbt1}}</span>
          <span>{{ssxgbt2}}</span>
          <span>{{ssxgbt3}}</span>
          <span>{{ssxgbt4}}</span>
          <span>{{ssxgbt5}}</span>
        </div>
      </div>
      <div class="cggy">
        <p class="title">成果概要</p>
        <div v-html="cggy">{{cggy}}</div>
      </div>
      <div class="qyjj">
        <p class="title">{{cgmc}}</p>
        <p>企业简介</p>
        <div v-html="qyjj">{{qyjj}}</div>
      </div>
      <div class="txt ssbj">
        <p class="top">一、实施背景</p>
        <div v-html="ssbjbt1" class="bt">{{ssbjbt1}}</div>
        <div v-html="ssbjnr1">{{ssbjnr1}}</div>
        <div v-html="ssbjbt2" class="bt">{{ssbjbt2}}</div>
        <div v-html="ssbjnr2">{{ssbjnr2}}</div>
        <div v-html="ssbjbt3" class="bt">{{ssbjbt3}}</div>
        <div v-html="ssbjnr3">{{ssbjnr3}}</div>
      </div>
      <div class="txt nh">
        <p class="top">二、内涵</p>
        <div v-html="nh">{{nh}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="nhtp1"
          :preview-src-list="[nhtp1]"
          v-if="nhtp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="nhtp2"
          :preview-src-list="[nhtp2]"
          v-if="nhtp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="nhtp3"
          :preview-src-list="[nhtp3]"
          v-if="nhtp3"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="nhtp4"
          :preview-src-list="[nhtp4]"
          v-if="nhtp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="nhtp5"
          :preview-src-list="[nhtp5]"
          v-if="nhtp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="nhtp6"
          :preview-src-list="[nhtp6]"
          v-if="nhtp6"
        ></el-image>
      </div>
      <div class="txt zyzf">
        <p class="top">三、主要做法</p>
        <div v-html="zyzfbt1" class="bt">{{zyzfbt1}}</div>
        <div v-html="zyzfnr1">{{zyzfnr1}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf1tp1"
          :preview-src-list="[zyzf1tp1]"
          v-if="zyzf1tp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf1tp2"
          :preview-src-list="[zyzf1tp2]"
          v-if="zyzf1tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf1tp3"
          :preview-src-list="[zyzf1tp3]"
          v-if="zyzf1tp3"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf1tp4"
          :preview-src-list="[zyzf1tp4]"
          v-if="zyzf1tp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf1tp5"
          :preview-src-list="[zyzf1tp5]"
          v-if="zyzf1tp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf1tp6"
          :preview-src-list="[zyzf1tp6]"
          v-if="zyzf1tp6"
        ></el-image>
        <div v-html="zyzfbt2" class="bt">{{zyzfbt2}}</div>
        <div v-html="zyzfnr2">{{zyzfnr2}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf2tp1"
          :preview-src-list="[zyzf2tp1]"
          v-if="zyzf2tp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf2tp2"
          :preview-src-list="[zyzf2tp2]"
          v-if="zyzf2tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf2tp3"
          :preview-src-list="[zyzf2tp3]"
          v-if="zyzf2tp3"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf2tp4"
          :preview-src-list="[zyzf2tp4]"
          v-if="zyzf2tp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf2tp5"
          :preview-src-list="[zyzf2tp5]"
          v-if="zyzf2tp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf2tp6"
          :preview-src-list="[zyzf2tp6]"
          v-if="zyzf2tp6"
        ></el-image>
        <div v-html="zyzfbt3" class="bt">{{zyzfbt3}}</div>
        <div v-html="zyzfnr3">{{zyzfnr3}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf3tp1"
          :preview-src-list="[zyzf3tp1]"
          v-if="zyzf3tp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf3tp2"
          :preview-src-list="[zyzf3tp2]"
          v-if="zyzf3tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf3tp3"
          :preview-src-list="[zyzf3tp3]"
          v-if="zyzf3tp3"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf3tp4"
          :preview-src-list="[zyzf3tp4]"
          v-if="zyzf3tp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf3tp5"
          :preview-src-list="[zyzf3tp5]"
          v-if="zyzf3tp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf3tp6"
          :preview-src-list="[zyzf3tp6]"
          v-if="zyzf3tp6"
        ></el-image>
        <div v-html="zyzfbt4" class="bt">{{zyzfbt4}}</div>
        <div v-html="zyzfnr4">{{zyzfnr4}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf4tp1"
          :preview-src-list="[zyzf4tp1]"
          v-if="zyzf4tp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf4tp2"
          :preview-src-list="[zyzf4tp2]"
          v-if="zyzf4tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf4tp3"
          :preview-src-list="[zyzf4tp3]"
          v-if="zyzf4tp3"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf4tp4"
          :preview-src-list="[zyzf4tp4]"
          v-if="zyzf4tp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf4tp5"
          :preview-src-list="[zyzf4tp5]"
          v-if="zyzf4tp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf4tp6"
          :preview-src-list="[zyzf4tp6]"
          v-if="zyzf4tp6"
        ></el-image>
        <div v-html="zyzfbt5" class="bt">{{zyzfbt5}}</div>
        <div v-html="zyzfnr5">{{zyzfnr5}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf5tp1"
          :preview-src-list="[zyzf5tp1]"
          v-if="zyzf5tp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf5tp2"
          :preview-src-list="[zyzf5tp2]"
          v-if="zyzf5tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf5tp3"
          :preview-src-list="[zyzf5tp3]"
          v-if="zyzf5tp3"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf5tp4"
          :preview-src-list="[zyzf5tp4]"
          v-if="zyzf5tp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf5tp5"
          :preview-src-list="[zyzf5tp5]"
          v-if="zyzf5tp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf5tp6"
          :preview-src-list="[zyzf5tp6]"
          v-if="zyzf5tp6"
        ></el-image>
        <div v-html="zyzfbt6" class="bt">{{zyzfbt6}}</div>
        <div v-html="zyzfnr6">{{zyzfnr6}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf6tp1"
          :preview-src-list="[zyzf6tp1]"
          v-if="zyzf6tp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf6tp2"
          :preview-src-list="[zyzf6tp2]"
          v-if="zyzf6tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf6tp3"
          :preview-src-list="[zyzf6tp3]"
          v-if="zyzf6tp3"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf6tp4"
          :preview-src-list="[zyzf6tp4]"
          v-if="zyzf6tp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf6tp5"
          :preview-src-list="[zyzf6tp5]"
          v-if="zyzf6tp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf6tp6"
          :preview-src-list="[zyzf6tp6]"
          v-if="zyzf6tp6"
        ></el-image>
        <div v-html="zyzfbt7" class="bt">{{zyzfbt7}}</div>
        <div v-html="zyzfnr7">{{zyzfnr7}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf7tp1"
          :preview-src-list="[zyzf7tp1]"
          v-if="zyzf7tp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf7tp2"
          :preview-src-list="[zyzf7tp2]"
          v-if="zyzf7tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf7tp3"
          :preview-src-list="[zyzf7tp3]"
          v-if="zyzf7tp3"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf7tp4"
          :preview-src-list="[zyzf7tp4]"
          v-if="zyzf7tp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf7tp5"
          :preview-src-list="[zyzf7tp5]"
          v-if="zyzf7tp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf7tp6"
          :preview-src-list="[zyzf7tp6]"
          v-if="zyzf7tp6"
        ></el-image>
      </div>
      <div class="txt ssxg">
        <p class="top">四、实施效果</p>
        <div v-html="ssxgbt1" class="bt">{{ssxgbt1}}</div>
        <div v-html="ssxgnr1">{{ssxgnr1}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg1tp1"
          :preview-src-list="[ssxg1tp1]"
          v-if="ssxg1tp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg1tp2"
          :preview-src-list="[ssxg1tp2]"
          v-if="ssxg1tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg1tp3"
          :preview-src-list="[ssxg1tp3]"
          v-if="ssxg1tp3"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg1tp4"
          :preview-src-list="[ssxg1tp4]"
          v-if="ssxg1tp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg1tp5"
          :preview-src-list="[ssxg1tp5]"
          v-if="ssxg1tp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg1tp6"
          :preview-src-list="[ssxg1tp6]"
          v-if="ssxg1tp6"
        ></el-image>
        <div v-html="ssxgbt2" class="bt">{{ssxgbt2}}</div>
        <div v-html="ssxgnr2">{{ssxgnr2}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg2tp1"
          :preview-src-list="[ssxg2tp1]"
          v-if="ssxg2tp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg2tp2"
          :preview-src-list="[ssxg2tp2]"
          v-if="ssxg2tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg2tp3"
          :preview-src-list="[ssxg2tp3]"
          v-if="ssxg2tp3"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg2tp4"
          :preview-src-list="[ssxg2tp4]"
          v-if="ssxg2tp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg2tp5"
          :preview-src-list="[ssxg2tp5]"
          v-if="ssxg2tp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg2tp6"
          :preview-src-list="[ssxg2tp6]"
          v-if="ssxg2tp6"
        ></el-image>
        <div v-html="ssxgbt3" class="bt">{{ssxgbt3}}</div>
        <div v-html="ssxgnr3">{{ssxgnr3}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg3tp1"
          :preview-src-list="[ssxg3tp1]"
          v-if="ssxg3tp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg3tp2"
          :preview-src-list="[ssxg3tp2]"
          v-if="ssxg3tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg3tp3"
          :preview-src-list="[ssxg3tp2]"
          v-if="ssxg3tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg3tp4"
          :preview-src-list="[ssxg3tp4]"
          v-if="ssxg3tp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg3tp5"
          :preview-src-list="[ssxg3tp5]"
          v-if="ssxg3tp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg3tp6"
          :preview-src-list="[ssxg3tp6]"
          v-if="ssxg3tp6"
        ></el-image>
        <div v-html="ssxgbt4" class="bt">{{ssxgbt4}}</div>
        <div v-html="ssxgnr4">{{ssxgnr4}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg4tp1"
          :preview-src-list="[ssxg4tp1]"
          v-if="ssxg4tp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg4tp2"
          :preview-src-list="[ssxg4tp2]"
          v-if="ssxg4tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg4tp3"
          :preview-src-list="[ssxg4tp3]"
          v-if="ssxg4tp3"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg4tp4"
          :preview-src-list="[ssxg4tp4]"
          v-if="ssxg4tp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg4tp5"
          :preview-src-list="[ssxg4tp5]"
          v-if="ssxg4tp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg4tp6"
          :preview-src-list="[ssxg4tp6]"
          v-if="ssxg4tp6"
        ></el-image>
        <div v-html="ssxgbt5" class="bt">{{ssxgbt5}}</div>
        <div v-html="ssxgnr5">{{ssxgnr5}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg5tp1"
          :preview-src-list="[ssxg5tp1]"
          v-if="ssxg5tp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg5tp2"
          :preview-src-list="[ssxg5tp2]"
          v-if="ssxg5tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg5tp3"
          :preview-src-list="[ssxg5tp3]"
          v-if="ssxg5tp3"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg5tp4"
          :preview-src-list="[ssxg5tp4]"
          v-if="ssxg5tp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg5tp5"
          :preview-src-list="[ssxg5tp5]"
          v-if="ssxg5tp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg5tp6"
          :preview-src-list="[ssxg5tp6]"
          v-if="ssxg5tp6"
        ></el-image>
      </div>
    </div>
    <div class="full" v-else>
      <div class="index">
        <div class="cover">
          <p class="title">{{year}}年煤炭企业管理现代化创新成果</p>
          <p class="name">主报告</p>
          <div>
            <p>成果名称：{{cgmc}}</p>
            <p>申报单位：{{sbdw}}</p>
          </div>
          <p class="footer">中国煤炭工业协会</p>
        </div>
      </div>
      <div class="catalogue">
        <p class="title">目录</p>
        <div>
          <p>成果概要</p>
          <p>企业简介</p>
          <p>一、实施背景</p>
          <span>{{ssbjbt1}}</span>
          <span>{{ssbjbt2}}</span>
          <span>{{ssbjbt3}}</span>
          <p>二、内涵</p>
          <p>三、主要做法</p>
          <span>{{zyzfbt1}}</span>
          <span>{{zyzfbt2}}</span>
          <span>{{zyzfbt3}}</span>
          <span>{{zyzfbt4}}</span>
          <span>{{zyzfbt5}}</span>
          <span>{{zyzfbt6}}</span>
          <span>{{zyzfbt7}}</span>
          <p>四、实施效果</p>
          <span>{{ssxgbt1}}</span>
          <span>{{ssxgbt2}}</span>
          <span>{{ssxgbt3}}</span>
          <span>{{ssxgbt4}}</span>
          <span>{{ssxgbt5}}</span>
        </div>
      </div>
      <div class="cggy">
        <p class="title">成果概要</p>
        <div v-html="cggy">{{cggy}}</div>
      </div>
      <div class="qyjj">
        <p class="title">{{cgmc}}</p>
        <p>企业简介</p>
        <div v-html="qyjj">{{qyjj}}</div>
      </div>
      <div class="txt ssbj">
        <p class="top">一、实施背景</p>
        <div v-html="ssbjbt1" class="bt">{{ssbjbt1}}</div>
        <div v-html="ssbjnr1">{{ssbjnr1}}</div>
        <div v-html="ssbjbt2" class="bt">{{ssbjbt2}}</div>
        <div v-html="ssbjnr2">{{ssbjnr2}}</div>
        <div v-html="ssbjbt3" class="bt">{{ssbjbt3}}</div>
        <div v-html="ssbjnr3">{{ssbjnr3}}</div>
      </div>
      <div class="txt nh">
        <p class="top">二、内涵</p>
        <div v-html="nh">{{nh}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="nhtp1"
          :preview-src-list="[nhtp1]"
          v-if="nhtp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="nhtp2"
          :preview-src-list="[nhtp2]"
          v-if="nhtp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="nhtp3"
          :preview-src-list="[nhtp3]"
          v-if="nhtp3"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="nhtp4"
          :preview-src-list="[nhtp4]"
          v-if="nhtp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="nhtp5"
          :preview-src-list="[nhtp5]"
          v-if="nhtp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="nhtp6"
          :preview-src-list="[nhtp6]"
          v-if="nhtp6"
        ></el-image>
      </div>
      <div class="txt zyzf">
        <p class="top">三、主要做法</p>
        <div v-html="zyzfbt1" class="bt">{{zyzfbt1}}</div>
        <div v-html="zyzfnr1">{{zyzfnr1}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf1tp1"
          :preview-src-list="[zyzf1tp1]"
          v-if="zyzf1tp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf1tp2"
          :preview-src-list="[zyzf1tp2]"
          v-if="zyzf1tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf1tp3"
          :preview-src-list="[zyzf1tp3]"
          v-if="zyzf1tp3"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf1tp4"
          :preview-src-list="[zyzf1tp4]"
          v-if="zyzf1tp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf1tp5"
          :preview-src-list="[zyzf1tp5]"
          v-if="zyzf1tp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf1tp6"
          :preview-src-list="[zyzf1tp6]"
          v-if="zyzf1tp6"
        ></el-image>
        <div v-html="zyzfbt2" class="bt">{{zyzfbt2}}</div>
        <div v-html="zyzfnr2">{{zyzfnr2}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf2tp1"
          :preview-src-list="[zyzf2tp1]"
          v-if="zyzf2tp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf2tp2"
          :preview-src-list="[zyzf2tp2]"
          v-if="zyzf2tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf2tp3"
          :preview-src-list="[zyzf2tp3]"
          v-if="zyzf2tp3"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf2tp4"
          :preview-src-list="[zyzf2tp4]"
          v-if="zyzf2tp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf2tp5"
          :preview-src-list="[zyzf2tp5]"
          v-if="zyzf2tp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf2tp6"
          :preview-src-list="[zyzf2tp6]"
          v-if="zyzf2tp6"
        ></el-image>
        <div v-html="zyzfbt3" class="bt">{{zyzfbt3}}</div>
        <div v-html="zyzfnr3">{{zyzfnr3}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf3tp1"
          :preview-src-list="[zyzf3tp1]"
          v-if="zyzf3tp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf3tp2"
          :preview-src-list="[zyzf3tp2]"
          v-if="zyzf3tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf3tp3"
          :preview-src-list="[zyzf3tp3]"
          v-if="zyzf3tp3"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf3tp4"
          :preview-src-list="[zyzf3tp4]"
          v-if="zyzf3tp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf3tp5"
          :preview-src-list="[zyzf3tp5]"
          v-if="zyzf3tp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf3tp6"
          :preview-src-list="[zyzf3tp6]"
          v-if="zyzf3tp6"
        ></el-image>
        <div v-html="zyzfbt4" class="bt">{{zyzfbt4}}</div>
        <div v-html="zyzfnr4">{{zyzfnr4}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf4tp1"
          :preview-src-list="[zyzf4tp1]"
          v-if="zyzf4tp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf4tp2"
          :preview-src-list="[zyzf4tp2]"
          v-if="zyzf4tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf4tp3"
          :preview-src-list="[zyzf4tp3]"
          v-if="zyzf4tp3"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf4tp4"
          :preview-src-list="[zyzf4tp4]"
          v-if="zyzf4tp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf4tp5"
          :preview-src-list="[zyzf4tp5]"
          v-if="zyzf4tp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf4tp6"
          :preview-src-list="[zyzf4tp6]"
          v-if="zyzf4tp6"
        ></el-image>
        <div v-html="zyzfbt5" class="bt">{{zyzfbt5}}</div>
        <div v-html="zyzfnr5">{{zyzfnr5}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf5tp1"
          :preview-src-list="[zyzf5tp1]"
          v-if="zyzf5tp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf5tp2"
          :preview-src-list="[zyzf5tp2]"
          v-if="zyzf5tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf5tp3"
          :preview-src-list="[zyzf5tp3]"
          v-if="zyzf5tp3"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf5tp4"
          :preview-src-list="[zyzf5tp4]"
          v-if="zyzf5tp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf5tp5"
          :preview-src-list="[zyzf5tp5]"
          v-if="zyzf5tp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf5tp6"
          :preview-src-list="[zyzf5tp6]"
          v-if="zyzf5tp6"
        ></el-image>
        <div v-html="zyzfbt6" class="bt">{{zyzfbt6}}</div>
        <div v-html="zyzfnr6">{{zyzfnr6}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf6tp1"
          :preview-src-list="[zyzf6tp1]"
          v-if="zyzf6tp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf6tp2"
          :preview-src-list="[zyzf6tp2]"
          v-if="zyzf6tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf6tp3"
          :preview-src-list="[zyzf6tp3]"
          v-if="zyzf6tp3"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf6tp4"
          :preview-src-list="[zyzf6tp4]"
          v-if="zyzf6tp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf6tp5"
          :preview-src-list="[zyzf6tp5]"
          v-if="zyzf6tp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf6tp6"
          :preview-src-list="[zyzf6tp6]"
          v-if="zyzf6tp6"
        ></el-image>
        <div v-html="zyzfbt7" class="bt">{{zyzfbt7}}</div>
        <div v-html="zyzfnr7">{{zyzfnr7}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf7tp1"
          :preview-src-list="[zyzf7tp1]"
          v-if="zyzf7tp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf7tp2"
          :preview-src-list="[zyzf7tp2]"
          v-if="zyzf7tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf7tp3"
          :preview-src-list="[zyzf7tp3]"
          v-if="zyzf7tp3"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf7tp4"
          :preview-src-list="[zyzf7tp4]"
          v-if="zyzf7tp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf7tp5"
          :preview-src-list="[zyzf7tp5]"
          v-if="zyzf7tp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="zyzf7tp6"
          :preview-src-list="[zyzf7tp6]"
          v-if="zyzf7tp6"
        ></el-image>
      </div>
      <div class="txt ssxg">
        <p class="top">四、实施效果</p>
        <div v-html="ssxgbt1" class="bt">{{ssxgbt1}}</div>
        <div v-html="ssxgnr1">{{ssxgnr1}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg1tp1"
          :preview-src-list="[ssxg1tp1]"
          v-if="ssxg1tp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg1tp2"
          :preview-src-list="[ssxg1tp2]"
          v-if="ssxg1tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg1tp3"
          :preview-src-list="[ssxg1tp3]"
          v-if="ssxg1tp3"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg1tp4"
          :preview-src-list="[ssxg1tp4]"
          v-if="ssxg1tp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg1tp5"
          :preview-src-list="[ssxg1tp5]"
          v-if="ssxg1tp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg1tp6"
          :preview-src-list="[ssxg1tp6]"
          v-if="ssxg1tp6"
        ></el-image>
        <div v-html="ssxgbt2" class="bt">{{ssxgbt2}}</div>
        <div v-html="ssxgnr2">{{ssxgnr2}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg2tp1"
          :preview-src-list="[ssxg2tp1]"
          v-if="ssxg2tp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg2tp2"
          :preview-src-list="[ssxg2tp2]"
          v-if="ssxg2tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg2tp3"
          :preview-src-list="[ssxg2tp3]"
          v-if="ssxg2tp3"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg2tp4"
          :preview-src-list="[ssxg2tp4]"
          v-if="ssxg2tp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg2tp5"
          :preview-src-list="[ssxg2tp5]"
          v-if="ssxg2tp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg2tp6"
          :preview-src-list="[ssxg2tp6]"
          v-if="ssxg2tp6"
        ></el-image>
        <div v-html="ssxgbt3" class="bt">{{ssxgbt3}}</div>
        <div v-html="ssxgnr3">{{ssxgnr3}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg3tp1"
          :preview-src-list="[ssxg3tp1]"
          v-if="ssxg3tp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg3tp2"
          :preview-src-list="[ssxg3tp2]"
          v-if="ssxg3tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg3tp3"
          :preview-src-list="[ssxg3tp2]"
          v-if="ssxg3tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg3tp4"
          :preview-src-list="[ssxg3tp4]"
          v-if="ssxg3tp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg3tp5"
          :preview-src-list="[ssxg3tp5]"
          v-if="ssxg3tp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg3tp6"
          :preview-src-list="[ssxg3tp6]"
          v-if="ssxg3tp6"
        ></el-image>
        <div v-html="ssxgbt4" class="bt">{{ssxgbt4}}</div>
        <div v-html="ssxgnr4">{{ssxgnr4}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg4tp1"
          :preview-src-list="[ssxg4tp1]"
          v-if="ssxg4tp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg4tp2"
          :preview-src-list="[ssxg4tp2]"
          v-if="ssxg4tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg4tp3"
          :preview-src-list="[ssxg4tp3]"
          v-if="ssxg4tp3"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg4tp4"
          :preview-src-list="[ssxg4tp4]"
          v-if="ssxg4tp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg4tp5"
          :preview-src-list="[ssxg4tp5]"
          v-if="ssxg4tp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg4tp6"
          :preview-src-list="[ssxg4tp6]"
          v-if="ssxg4tp6"
        ></el-image>
        <div v-html="ssxgbt5" class="bt">{{ssxgbt5}}</div>
        <div v-html="ssxgnr5">{{ssxgnr5}}</div>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg5tp1"
          :preview-src-list="[ssxg5tp1]"
          v-if="ssxg5tp1"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg5tp2"
          :preview-src-list="[ssxg5tp2]"
          v-if="ssxg5tp2"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg5tp3"
          :preview-src-list="[ssxg5tp3]"
          v-if="ssxg5tp3"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg5tp4"
          :preview-src-list="[ssxg5tp4]"
          v-if="ssxg5tp4"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg5tp5"
          :preview-src-list="[ssxg5tp5]"
          v-if="ssxg5tp5"
        ></el-image>
        <el-image
          style="width: 2rem; height: 2rem"
          :src="ssxg5tp6"
          :preview-src-list="[ssxg5tp6]"
          v-if="ssxg5tp6"
        ></el-image>
      </div>
    </div>
    <!-- <el-dialog title="" :visible.sync="dialogVisible12">
        <img :src="Bigsrc" alt="" style="max-width:100%; display:block;margin:0 auto">
    </el-dialog>-->
  </div>
</template>
<script>
export default {
  name: "FullPreview",
  data() {
    return {
      // dialogVisible12:false,
      // Bigsrc:"",
      ReportID: "",
      cgmc: "",
      sbdw: "",
      cggy: "",
      qyjj: "",
      ssbjbt1: "",
      ssbjnr1: "",
      ssbjbt2: "",
      ssbjnr2: "",
      ssbjbt3: "",
      ssbjnr3: "",
      nh: "",
      nhtp1: "",
      nhtp2: "",
      nhtp3: "",
      nhtp4: "",
      nhtp5: "",
      nhtp6: "",
      zyzfbt1: "",
      zyzfnr1: "",
      zyzfbt2: "",
      zyzfnr2: "",
      zyzfbt3: "",
      zyzfnr3: "",
      zyzfbt4: "",
      zyzfnr4: "",
      zyzfbt5: "",
      zyzfnr5: "",
      zyzfbt6: "",
      zyzfnr6: "",
      zyzfbt7: "",
      zyzfnr7: "",
      zyzf1tp1: "",
      zyzf1tp2: "",
      zyzf1tp3: "",
      zyzf1tp4: "",
      zyzf1tp5: "",
      zyzf1tp6: "",
      zyzf2tp1: "",
      zyzf2tp2: "",
      zyzf2tp3: "",
      zyzf2tp4: "",
      zyzf2tp5: "",
      zyzf2tp6: "",
      zyzf3tp1: "",
      zyzf3tp2: "",
      zyzf3tp3: "",
      zyzf3tp4: "",
      zyzf3tp5: "",
      zyzf3tp6: "",
      zyzf4tp1: "",
      zyzf4tp2: "",
      zyzf4tp3: "",
      zyzf4tp4: "",
      zyzf4tp5: "",
      zyzf4tp6: "",
      zyzf5tp1: "",
      zyzf5tp2: "",
      zyzf5tp3: "",
      zyzf5tp4: "",
      zyzf5tp5: "",
      zyzf5tp6: "",
      zyzf6tp1: "",
      zyzf6tp2: "",
      zyzf6tp3: "",
      zyzf6tp4: "",
      zyzf6tp5: "",
      zyzf6tp6: "",
      zyzf7tp1: "",
      zyzf7tp2: "",
      zyzf7tp3: "",
      zyzf7tp4: "",
      zyzf7tp5: "",
      zyzf7tp6: "",
      ssxgbt1: "",
      ssxgnr1: "",
      ssxgbt2: "",
      ssxgnr2: "",
      ssxgbt3: "",
      ssxgnr3: "",
      ssxgbt4: "",
      ssxgnr4: "",
      ssxgbt5: "",
      ssxgnr5: "",
      ssxg1tp1: "",
      ssxg1tp2: "",
      ssxg1tp3: "",
      ssxg1tp4: "",
      ssxg1tp5: "",
      ssxg1tp6: "",
      ssxg2tp1: "",
      ssxg2tp2: "",
      ssxg2tp3: "",
      ssxg2tp4: "",
      ssxg2tp5: "",
      ssxg2tp6: "",
      ssxg3tp1: "",
      ssxg3tp2: "",
      ssxg3tp3: "",
      ssxg3tp4: "",
      ssxg3tp5: "",
      ssxg3tp6: "",
      ssxg4tp1: "",
      ssxg4tp2: "",
      ssxg4tp3: "",
      ssxg4tp4: "",
      ssxg4tp5: "",
      ssxg4tp6: "",
      ssxg5tp1: "",
      ssxg5tp2: "",
      ssxg5tp3: "",
      ssxg5tp4: "",
      ssxg5tp5: "",
      ssxg5tp6: ""
    };
  },
  props: ["zbg"],
  computed:{
    year(){
      var time=new Date()
      return time.getFullYear()
    }
  },

  mounted() {
    console.log(this.zbg);
    // let that=this
    if (sessionStorage.getItem("isListGo") == "true") {
      this.ReportID = sessionStorage.getItem("reportID");
    } else {
      this.ReportID = sessionStorage.getItem("ReportID");
    }
    this.getReportcontent();
    // 图片放大
    // let imgs = document.getElementsByTagName("img");
    // // console.log(img);
    // imgs.forEach(val => {
    //   val.onclick = function(){
    //     // console.log(val.src)
    //     that.dialogVisible12=true
    //     that.Bigsrc=val.src
    //   };
    // });
  },
  methods: {
    //获取预览内容
    getReportcontent() {
      var that = this;
      that.$axios
        .post(
          "reportcontent/info?token=" + sessionStorage.getItem("token"),
          that.$qs.stringify({
            ReportID: that.zbg || that.ReportID,
            MouldID: "MD1"
          })
        )
        .then(res => {
          if (res.data.code == 10000) {
            console.log(res.data.data, "预览报告");
            that.contentInfo = res.data.data;
            that.contentInfo.forEach(val => {
              if (val.Title == "cgmc") {
                that.cgmc = val.Content;
              }
              if (val.Title == "sbdw") {
                that.sbdw = val.Content;
              }
              if (val.Title == "cgzbg_cggy") {
                that.cggy = val.Content;
              }
              if (val.Title == "cgzbg_qyjj") {
                that.qyjj = val.Content;
              }
              if (val.Title == "cgzbg_ssbjbt1") {
                that.ssbjbt1 = val.Content;
              }
              if (val.Title == "cgzbg_ssbjnr1") {
                that.ssbjnr1 = val.Content;
              }
              if (val.Title == "cgzbg_ssbjbt2") {
                that.ssbjbt2 = val.Content;
              }
              if (val.Title == "cgzbg_ssbjnr2") {
                that.ssbjnr2 = val.Content;
              }
              if (val.Title == "cgzbg_ssbjbt3") {
                that.ssbjbt3 = val.Content;
              }
              if (val.Title == "cgzbg_ssbjnr3") {
                that.ssbjnr3 = val.Content;
              }
              if (val.Title == "cgzbg_nh") {
                that.nh = val.Content;
              }
              if (val.Title == "cgzbg_nhtp1") {
                that.nhtp1 = val.Content;
              }
              if (val.Title == "cgzbg_nhtp2") {
                that.nhtp2 = val.Content;
              }
              if (val.Title == "cgzbg_nhtp3") {
                that.nhtp3 = val.Content;
              }
              if (val.Title == "cgzbg_nhtp4") {
                that.nhtp4 = val.Content;
              }
              if (val.Title == "cgzbg_nhtp5") {
                that.nhtp5 = val.Content;
              }
              if (val.Title == "cgzbg_nhtp6") {
                that.nhtp6 = val.Content;
              }
              if (val.Title == "cgzbg_zyzfbt1") {
                that.zyzfbt1 = val.Content;
              }
              if (val.Title == "cgzbg_zyzfnr1") {
                that.zyzfnr1 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf1tp1") {
                that.zyzf1tp1 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf1tp2") {
                that.zyzf1tp2 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf1tp3") {
                that.zyzf1tp3 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf1tp4") {
                that.zyzf1tp4 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf1tp5") {
                that.zyzf1tp5 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf1tp6") {
                that.zyzf1tp6 = val.Content;
              }
              if (val.Title == "cgzbg_zyzfbt2") {
                that.zyzfbt2 = val.Content;
              }
              if (val.Title == "cgzbg_zyzfnr2") {
                that.zyzfnr2 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf2tp1") {
                that.zyzf2tp1 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf2tp2") {
                that.zyzf2tp2 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf2tp3") {
                that.zyzf2tp3 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf2tp4") {
                that.zyzf2tp4 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf2tp5") {
                that.zyzf2tp5 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf2tp6") {
                that.zyzf2tp6 = val.Content;
              }
              if (val.Title == "cgzbg_zyzfbt3") {
                that.zyzfbt3 = val.Content;
              }
              if (val.Title == "cgzbg_zyzfnr3") {
                that.zyzfnr3 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf3tp1") {
                that.zyzf3tp1 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf3tp2") {
                that.zyzf3tp2 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf3tp3") {
                that.zyzf3tp3 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf3tp4") {
                that.zyzf3tp4 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf3tp5") {
                that.zyzf3tp5 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf3tp6") {
                that.zyzf3tp6 = val.Content;
              }
              if (val.Title == "cgzbg_zyzfbt4") {
                that.zyzfbt4 = val.Content;
              }
              if (val.Title == "cgzbg_zyzfnr4") {
                that.zyzfnr4 = val.Content;
              }
              if (val.Title == "cgzbg_zyzfbt5") {
                that.zyzfbt5 = val.Content;
              }
              if (val.Title == "cgzbg_zyzfnr5") {
                that.zyzfnr5 = val.Content;
              }
              if (val.Title == "cgzbg_zyzfbt6") {
                that.zyzfbt6 = val.Content;
              }
              if (val.Title == "cgzbg_zyzfnr6") {
                that.zyzfnr6 = val.Content;
              }
              if (val.Title == "cgzbg_zyzfbt7") {
                that.zyzfbt7 = val.Content;
              }
              if (val.Title == "cgzbg_zyzfnr7") {
                that.zyzfnr7 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf4tp1") {
                that.zyzf4tp1 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf4tp2") {
                that.zyzf4tp2 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf4tp3") {
                that.zyzf4tp3 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf4tp4") {
                that.zyzf4tp4 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf4tp5") {
                that.zyzf4tp5 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf4tp6") {
                that.zyzf4tp6 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf5tp1") {
                that.zyzf5tp1 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf5tp2") {
                that.zyzf5tp2 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf5tp3") {
                that.zyzf5tp3 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf5tp4") {
                that.zyzf5tp4 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf5tp5") {
                that.zyzf5tp5 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf5tp6") {
                that.zyzf5tp6 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf6tp1") {
                that.zyzf6tp1 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf6tp2") {
                that.zyzf6tp2 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf6tp3") {
                that.zyzf6tp3 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf6tp4") {
                that.zyzf6tp4 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf6tp5") {
                that.zyzf6tp5 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf6tp6") {
                that.zyzf6tp6 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf7tp1") {
                that.zyzf7tp1 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf7tp2") {
                that.zyzf7tp2 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf7tp3") {
                that.zyzf7tp3 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf7tp4") {
                that.zyzf7tp4 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf7tp5") {
                that.zyzf7tp5 = val.Content;
              }
              if (val.Title == "cgzbg_zyzf7tp6") {
                that.zyzf7tp6 = val.Content;
              }
              if (val.Title == "cgzbg_ssxgbt1") {
                that.ssxgbt1 = val.Content;
              }
              if (val.Title == "cgzbg_ssxgnr1") {
                that.ssxgnr1 = val.Content;
              }
              if (val.Title == "cgzbg_ssxgbt2") {
                that.ssxgbt2 = val.Content;
              }
              if (val.Title == "cgzbg_ssxgnr2") {
                that.ssxgnr2 = val.Content;
              }
              if (val.Title == "cgzbg_ssxgbt3") {
                that.ssxgbt3 = val.Content;
              }
              if (val.Title == "cgzbg_ssxgnr3") {
                that.ssxgnr3 = val.Content;
              }
              if (val.Title == "cgzbg_ssxgbt4") {
                that.ssxgbt4 = val.Content;
              }
              if (val.Title == "cgzbg_ssxgnr4") {
                that.ssxgnr4 = val.Content;
              }
              if (val.Title == "cgzbg_ssxgbt5") {
                that.ssxgbt5 = val.Content;
              }
              if (val.Title == "cgzbg_ssxgnr5") {
                that.ssxgnr5 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg1tp1") {
                that.ssxg1tp1 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg1tp2") {
                that.ssxg1tp2 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg1tp3") {
                that.ssxg1tp3 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg1tp4") {
                that.ssxg1tp4 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg1tp5") {
                that.ssxg1tp5 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg1tp6") {
                that.ssxg1tp6 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg2tp1") {
                that.ssxg2tp1 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg2tp2") {
                that.ssxg2tp2 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg2tp3") {
                that.ssxg2tp3 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg2tp4") {
                that.ssxg2tp4 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg2tp5") {
                that.ssxg2tp5 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg2tp6") {
                that.ssxg2tp6 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg3tp1") {
                that.ssxg3tp1 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg3tp2") {
                that.ssxg3tp2 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg3tp3") {
                that.ssxg3tp3 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg3tp4") {
                that.ssxg3tp4 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg3tp5") {
                that.ssxg3tp5 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg3tp6") {
                that.ssxg3tp6 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg4tp1") {
                that.ssxg4tp1 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg4tp2") {
                that.ssxg4tp2 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg4tp3") {
                that.ssxg4tp3 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg4tp4") {
                that.ssxg4tp4 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg4tp5") {
                that.ssxg4tp5 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg4tp6") {
                that.ssxg4tp6 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg5tp1") {
                that.ssxg5tp1 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg5tp2") {
                that.ssxg5tp2 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg5tp3") {
                that.ssxg5tp3 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg5tp4") {
                that.ssxg5tp4 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg5tp5") {
                that.ssxg5tp5 = val.Content;
              }
              if (val.Title == "cgzbg_ssxg5tp6") {
                that.ssxg5tp6 = val.Content;
              }
            });
          } else if (res.data.code == 10002) {
            this.$message({
              type: "warning",
              message: res.data.msg
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    }
  }
};
</script>
<style lang="less">
#FullPreview {
  p {
    font-family: "Microsoft Yahei", "PingFang SC", "Avenir", "Segoe UI",
      "Hiragino Sans GB", STHeiti, "Microsoft Sans Serif", "WenQuanYi Micro Hei",
      sans-serif !important;
    line-height: 2 !important;
  }
  span {
    font-size: 0.24rem !important;
    font-family: "Microsoft Yahei", "PingFang SC", "Avenir", "Segoe UI",
      "Hiragino Sans GB", STHeiti, "Microsoft Sans Serif", "WenQuanYi Micro Hei",
      sans-serif !important;
    font-weight: normal !important;
  }
  font {
    font-family: "Microsoft Yahei", "PingFang SC", "Avenir", "Segoe UI",
      "Hiragino Sans GB", STHeiti, "Microsoft Sans Serif", "WenQuanYi Micro Hei",
      sans-serif !important;
  }
  .el-image {
    margin-right: 0.2rem;
  }
  .el-image-viewer__wrapper {
    // top: 0rem;
    // left: 5.55rem;
    // width: 11.68rem;
    // height: 8rem;
  }
  .el-icon-circle-close:before {
    content: "";
  }
  .el-image-viewer__close {
    background: url("../../assets/back/guanbi.png") no-repeat;
  }
  .full {
    .cggy,
    .qyjj,
    .nh {
      > div {
        p {
          margin-bottom: 0.2rem;
        }
      }
    }
    .ssbj,
    .zyzf,
    .ssxg {
      > div {
        margin-bottom: 0.4rem;
      }
      .bt {
        font-weight: bold;
        margin-bottom: 0.1rem;
      }
    }
  }
}
</style>
<style lang="less" scoped>
#FullPreview {
  width: 100%;
  .full {
    width: 95%;
    margin: 0 auto;
    .title {
      font-size: 0.4rem;
      text-align: center;
      margin-bottom: 0.5rem;
    }
    .index {
      margin: 0 auto;
      .cover {
        margin-top: 0.5rem;
        text-align: center;
        .title {
          font-size: 0.4rem;
        }
        .name {
          font-size: 0.6rem;
          font-weight: bold;
          margin-top: 1rem;
        }
        div {
          font-size: 0.3rem;
          text-align: left;
          margin-top: 3rem;
          p {
            margin-bottom: 0.3rem;
          }
        }
        .footer {
          font-size: 0.27rem;
          margin: 1.5rem 0 1.8rem;
        }
      }
    }
    .catalogue {
      margin: 0.5rem 0 4rem;
      div {
        font-size: 0.24rem;
        p {
          margin-bottom: 0.2rem;
        }
        span {
          display: block;
          margin: 0 0 0.2rem 0.3rem;
        }
      }
    }
    .cggy {
      margin-bottom: 2rem;
      div {
        font-size: 0.24rem;
      }
    }
    .qyjj {
      margin-bottom: 2rem;
      p:nth-of-type(2) {
        font-size: 0.3rem;
        margin-bottom: 0.2rem;
      }
      div {
        font-size: 0.24rem;
      }
    }
    .txt {
      margin-bottom: 2rem;
      font-size: 0.3rem;
      p {
        margin-bottom: 0.2rem;
      }
      div {
        font-size: 0.24rem;
      }
      // img {
      //   width: 2rem;
      //   height: 2rem;
      //   margin-right: 0.2rem;
      //   transform: scale(1);
      //   transition: all ease 0.5s;
      // }
      // img.active {
      //   transform: scale(3);
      //   z-index: 100;
      // }
    }
  }
}
</style>